import { useCallback, useEffect, useState } from "react";

import { cybervolunteerApi } from "../../api/cybervolunteerApi";
import Header from "../../components/Header";
import type {
  QuestionOptionType,
  QuestionType,
  QuestionWithContentType,
} from "./CreateTaskPageTypes";

const CreateTaskPage = () => {
  const [allQuestions, setAllQuestions] = useState<Array<QuestionType>>([]);
  const [allQuestionContent, setAllQuestionContent] = useState<Array<QuestionWithContentType>>([]);
  const [taskTitle, setTaskTitle] = useState<string>("");
  const [taskDescription, setTaskDescription] = useState<string>("");
  const [taskText, setTaskText] = useState<string>("");
  const [taskIsHero, setTaskIsHero] = useState<boolean>(false);

  const updateQuestion = (question_id: number, new_question: QuestionType) => {
    const a = allQuestions.map((question, question_n) => {
      if (question_n === question_id) {
        return new_question;
      } else {
        return question;
      }
    });
    setAllQuestions(a);
  };
  const updateQuestionOption = (
    question_id: number,
    new_question_option_id: number,
    new_question_option: QuestionOptionType
  ) => {
    const new_question = allQuestions.map((old_question, old_question_id) => {
      if (old_question_id === question_id) {
        /* istanbul ignore else -- option editors only mount with initialized content */
        if (old_question.content) {
          return {
            ...old_question,
            content: old_question.content.map((old_question_option, old_question_option_id) => {
              if (old_question_option_id === new_question_option_id) {
                return new_question_option;
              } else {
                return old_question_option;
              }
            }),
          };
        } else {
          /* istanbul ignore next -- option edits only render when content exists */
          return old_question;
        }
      } else {
        return old_question;
      }
    });
    setAllQuestions(new_question);
  };
  const addQuestionOption = (question_id: number, new_question_option: QuestionOptionType) => {
    setAllQuestions(
      allQuestions.map((old_question, old_question_id) => {
        if (old_question_id === question_id) {
          /* istanbul ignore else -- '+' only appears once CH/RD content is initialized */
          if (old_question.content) {
            return {
              ...old_question,
              content: old_question.content.concat(new_question_option),
            };
          } else {
            /* istanbul ignore next -- '+' only appears once CH/RD content is initialized */
            return old_question;
          }
        } else {
          return old_question;
        }
      })
    );
  };

  const sendTask = useCallback(() => {
    const token = localStorage.getItem("auth_token");
    console.log("TOKEN: ", token);
    cybervolunteerApi
      .createSubtask({
        title: taskTitle,
        description: taskDescription,
        text: taskText,
        is_hero: taskIsHero,
        questions: allQuestionContent.map((question1) => {
          return {
            type1: question1.type1,
            content: JSON.parse(question1.content),
          };
        }),
      })
      .then((_response) => {
        console.log("Ok");
        window.location.href = "/task_list_admin";
      })
      .catch((error: { response?: { status?: number } }) => {
        console.error("There was an error pushing the data!", error);

        if (error.response?.status === 405) {
          window.location.href = "/";
        }
      });
  }, [allQuestionContent, taskText, taskTitle, taskDescription, taskIsHero]);

  useEffect(() => {
    const newTaskContent: Array<QuestionWithContentType> = allQuestions.map((old_question) => {
      return {
        type1: old_question.type1,
        content: old_question.content
          ? JSON.stringify({
              title: old_question.title,
              options: old_question.content.map((question_n, question_id) => {
                return { id: question_id, text: question_n.title };
              }),
            })
          : JSON.stringify({ title: old_question.title }),
      };
    });
    setAllQuestionContent(newTaskContent);
  }, [allQuestions]);

  return (
    <div className="main-body border-l-orange-100 md:pb-10">
      <Header />
      <main className="w-full">
        <main className="text-black">
          <section className="relative w-full container flex justify-between mx-auto flex-col">
            <button
              type="button"
              data-testid="back-to-task-list-admin"
              className="m-3 self-start rounded-lg border-2 border-slate-400 px-4 py-2 text-lg text-slate-800 hover:bg-slate-100"
              onClick={() => {
                window.location.href = "/task_list_admin";
              }}
            >
              {"< Back"}
            </button>
            <div className="flex">
              <h3 className="m-3 text-3xl">Имя задачи</h3>
              <input
                type="text"
                value={taskTitle}
                className="border-2 m-3 rounded-lg"
                onChange={(e) => setTaskTitle(e.target.value)}
              ></input>
            </div>
            <div className="flex">
              <h3 className="m-3 text-3xl">Описание задачи</h3>
              <input
                type="text"
                value={taskDescription}
                className="border-2 m-3 rounded-lg"
                onChange={(e) => setTaskDescription(e.target.value)}
              ></input>
            </div>
            <div className="flex flex-col">
              <h3 className="m-3 text-3xl">Текст задачи</h3>
              <textarea
                className="border-2 m-3 rounded-lg w-auto text-black text-2xl h-80"
                value={taskText}
                onChange={(e) => setTaskText(e.target.value)}
              />
            </div>
            <div className="flex items-center m-3">
              <input
                id="task-is-hero"
                data-testid="task-is-hero"
                type="checkbox"
                className="w-5 h-5 mr-3"
                checked={taskIsHero}
                onChange={(e) => setTaskIsHero(e.target.checked)}
              />
              <label htmlFor="task-is-hero" className="text-2xl">
                Hero-задача (без ответов, всегда раскрыта)
              </label>
            </div>

            <div className="flex flex-col">
              <button
                onClick={() =>
                  setAllQuestions([
                    ...allQuestions,
                    {
                      title: "",
                      type1: "TX",
                      content: null,
                    },
                  ])
                }
                className="text-white bg-slate-600 m-3 p-2 px-12 rounded-lg md:max-w-72 max-w-full text-center"
              >
                Добавить вопрос
              </button>
              {allQuestions.map((task, tasknum) => {
                return (
                  <div key={tasknum} className="flex flex-col m-3 text-2xl">
                    <div className="flex flex-row bg-gray-200 p-3 rounded-xl justify-between">
                      <h2 className="m-3 p-2">{tasknum}</h2>
                      <input
                        type="text"
                        placeholder="название"
                        className="m-3 p-2 bg-white"
                        value={task.title}
                        onChange={(e) =>
                          updateQuestion(tasknum, {
                            ...task,
                            title: e.target.value,
                          })
                        }
                      />
                      <select
                        className="m-3 bg-white p-2 px-6 rounded-lg"
                        value={task.type1}
                        onChange={(e) =>
                          updateQuestion(tasknum, {
                            ...task,
                            type1: e.target.value,
                            content: e.target.value === "CH" || e.target.value === "RD" ? [] : null,
                          })
                        }
                      >
                        <option value="TX">текст</option>
                        <option value="CH">чекбокс</option>
                        <option value="RD">радио</option>
                      </select>
                      {task.type1 === "TX" ? (
                        <></>
                      ) : (
                        <div className="flex flex-col">
                          {(() => {
                            /* istanbul ignore next -- select initializes content as [] for CH/RD */
                            const rows = task.content || [];
                            return (
                              <>
                                {rows.map((question_option, question_opton_id) => (
                                  <div key={question_opton_id}>
                                    <input
                                      value={question_option.title}
                                      type="text"
                                      className="border-2 m-3 mr-0 rounded-lg p-1 rounded-r-none"
                                      onChange={(e) =>
                                        updateQuestionOption(tasknum, question_opton_id, {
                                          ...question_option,
                                          title: e.target.value,
                                        })
                                      }
                                    />
                                    <button className="text-sm text-white ml-0 rounded-l-none bg-slate-600 m-3 p-2 px-4 rounded-lg md:max-w-72 max-w-full text-center">
                                      -
                                    </button>
                                  </div>
                                ))}
                                <button
                                  onClick={() =>
                                    addQuestionOption(tasknum, {
                                      id: rows.length + 1,
                                      title: "",
                                    })
                                  }
                                  className="text-sm text-white bg-slate-600 m-3 p-2 px-12 rounded-lg md:max-w-72 max-w-full text-center"
                                >
                                  +
                                </button>
                              </>
                            );
                          })()}
                        </div>
                      )}
                      <button className="text-sm text-white bg-slate-600 m-3 p-2 px-12 rounded-lg md:max-w-72 max-w-full text-center">
                        удалить вопрос
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
            <button
              onClick={sendTask}
              className="text-white bg-slate-600 m-3 p-2 px-12 rounded-lg md:max-w-72 max-w-full text-center"
            >
              Добавить задачу
            </button>
          </section>
        </main>
      </main>
    </div>
  );
};

export default CreateTaskPage;
